import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import MemberCard from "./memberCard";
import CardLightbox from "./cardLightbox";
import { findBelt } from "./cardsData";
import { formatDate } from "../../utils/formatDate";
import { fullName } from "../../utils/fullName";

const PLACE_TYPES = {
  schools: "Դպրոց",
  clubs: "Ակումբ",
  federation: "Մարզային ֆեդերացիա",
};

const Overview = () => {
  const { user } = useAuth();
  const [viewing, setViewing] = useState(false);

  const rows = [
    ["Անուն", user.firstname],
    ["Ազգանուն", user.surname],
    ["Հայրանուն", user.patronymic],
    [
      "Անդամավճար",
      user.membership?.valid_until
        ? `${user.membership.status === "active" ? "Գործում է" : "Ժամկետանց"} մինչև ${formatDate(user.membership.valid_until)}`
        : "Չի վճարված",
    ],
    ["Էլ. հասցե", user.email],
    ["Ծննդյան ամսաթիվ", formatDate(user.date_of_birth)],
    ["Սեռ", user.sex],
    ["Բնակության հասցե", user.address],
    ["Հեռախոս", user.phone],
    [
      "Կազմակերպություն",
      user.place &&
        `${user.place.name}${PLACE_TYPES[user.place.type] ? ` (${PLACE_TYPES[user.place.type]})` : ""}`,
    ],
    ["Կազմակերպության հասցե", user.place?.location],
    ["Մարզիչ", user.trainer && fullName(user.trainer)],
  ].filter(([, value]) => value);

  return (
    <div className="account-panel">
      <h2 className="account-title">Իմ էջը</h2>
      <ul className="profile-list">
        {rows.map(([label, value]) => (
          <li key={label}>
            <span>{label}</span>
            <span>{value}</span>
          </li>
        ))}
      </ul>

      <h3 className="account-subtitle">Իմ քարտը</h3>
      <div className="account-card-preview">
        <MemberCard belt={user.belt || "white"} user={user} onClick={() => setViewing(true)} />
      </div>
      {user.belt_request && (
        <p className="auth-muted">
          Սպասում է հաստատման՝ {findBelt(user.belt_request.belt)?.label} քարտ։{" "}
          <Link to="/profile/cards">Քարտեր</Link>
        </p>
      )}

      {viewing && (
        <CardLightbox
          belts={[user.belt || "white"]}
          index={0}
          user={user}
          onClose={() => setViewing(false)}
          onChange={() => {}}
        />
      )}
    </div>
  );
};

export default Overview;
